module.exports = __webpack_public_path__ + "static/media/by.df1138dd.png";